import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'
const EasyPayLayout = () => {
    const { pathname } = useLocation()
    useHelmet('پرداخت آسان')

    return (
        <div className="sm:w-full md:px-[35%] relative md:bg-bg-md-screen">
            <div className="bg-main-bg">
                <motion.div
                    key={pathname}
                    initial={{ opacity: 0, x: '100%' }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: '-100%' }}
                    transition={{ duration: 0.2 }}
                    className="w-100 vh-100"
                >
                    <Outlet />
                </motion.div>
            </div>
        </div>
    )
}

export default EasyPayLayout
